import type { RegisterParams } from '@common/workflow/serviceActivityRegistry';
import { CustomControlCode } from '@common/enums';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { tpoFlexBiometryDraftSchema, tpoFlexBiometryFinalSchema } from './tpoFlexBiometrySchema';
import { tpoFlexGradingDraftSchema, tpoFlexGradingFinalSchema } from './tpoFlexGradingSchema';

const registryElements: RegisterParams[] = [
    {
        customControlCode: CustomControlCode.TPOFlexBiometry,
        draft: tpoFlexBiometryDraftSchema,
        final: tpoFlexBiometryFinalSchema,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.TPOFlexGrading,
        draft: tpoFlexGradingDraftSchema,
        final: tpoFlexGradingFinalSchema,
        version: 1,
    },
];

ServiceActivityRegistry.instance.registerAll(registryElements);
